var map = {
	"./V.png": 44466,
	"./arrow-filled.png": 85794,
	"./back.png": 50264,
	"./banner/banner1.png": 13846,
	"./banner/banner2.png": 75656,
	"./classicphone.png": 75917,
	"./clear.png": 63374,
	"./close.png": 86850,
	"./default-device.png": 4147,
	"./defaultCover.png": 95816,
	"./dji-store.png": 17045,
	"./emoji.png": 47460,
	"./empty.png": 16620,
	"./hardware-empty-icon.png": 57602,
	"./link.png": 80126,
	"./logo.png": 8921,
	"./photo-default-audit.png": 33978,
	"./photo-default-cover.png": 44159,
	"./photo.png": 36618,
	"./play-icon.png": 62430,
	"./play.png": 34563,
	"./publish-succcess-icon.png": 61955,
	"./sort-dorp-down-active.png": 13858,
	"./sort-dorp-down.png": 31255,
	"./video-default-cover.png": 29109,
	"./video.png": 38087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56680;